<template>
    <div class="overflow-hidden"
        style="padding:0px 0px; margin-top:0px; background-color: #f2f7fa; border-radius: 10px;">
        <div class="flex justify-between mx-4">
            <div class="flex pt-2 pb-2">
                <el-select size="small" clearable v-model="selectStatus" @change="handleSelectChange"
                    placeholder="Select Status">
                    <el-option v-for="(status, key) in status" :key="key" :label="status.label" :value="status.value">
                    </el-option>
                </el-select>
                <el-date-picker v-model="dateRange" type="datetimerange" range-separator="-"
                    start-placeholder="Start Date" end-placeholder="End Date" format="dd/MM/yyyy HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" size="small" style="margin-left: 8px;" :prefix-icon="null"
                    @change="handleSelectChange">
                    <span slot="suffix">
                        <svg-icon iconClass="calendar" />
                    </span>
                </el-date-picker>
            </div>
            <div class="flex pt-2 pb-2">
                <el-input style="margin-right: 8px;" size="small" :placeholder="$t('btn.search')" v-model="searchValue"
                    @keyup.enter.native="getList">
                    <span slot="suffix" @click="getList">
                        <svg-icon iconClass="search" />
                    </span>
                </el-input>
                <el-button plain @click="createCert" size="small" class="pb-2" v-if="this.userInfo.userType != '2'">
                    Create a New Holding Certificate
                </el-button>
            </div>
        </div>
        <div class="flex justify-center">
            <div class="w-full Comtable">
                <el-table :data="listData"
                    :header-cell-style="{ height: '55px', background: '#fff', 'border-bottom': '2px solid #D6D9E1', }"
                    :cell-style="getCellStyle" table-layout="auto" height="100%" @row-click="handleTableRowClick">
                    <el-table-column align="left" prop="id" min-width='200px' label="Reference ID" />
                    <el-table-column align="left" prop="toCompany" min-width='200px' label="Bank" />
                    <el-table-column align="left" prop="copyCompany" min-width='200px' label="Customer" />
                    <el-table-column align="left" prop="tanks" min-width='200px' label="Tank">
                        <template #default="scope">
                            <div v-for="tank in scope.row.tanks" :key="tank">
                                {{ tank }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="products" min-width='200px' label="Product">
                        <template #default="scope">
                            <div v-for="product in scope.row.products" :key="product">
                                {{ product }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column align="left" prop="createTime" min-width='200px' label="Date Created">
                    </el-table-column>
                    <el-table-column align="left" prop="status" min-width='150px' label="Status">
                        <template #default="scope">
                            <p :style="getStatusColor(scope.row.status)">{{ getStatusLabel(scope.row.status) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="action" min-width="250">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click.stop="handleViewPdf(scope.row.id)">View in
                                PDF</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="barging-pagination">
            <pagination :total="total" :page.sync="pageParams.pageNum" :limit.sync="pageParams.pageSize"
                @pagination="getList">
            </pagination>
        </div>
        <pdf-view v-if="holdingCertUrl" :title="'Holding Cert'" :pdf-url="holdingCertUrl" v-model="showPdfView" />
    </div>
</template>

<script>
import PdfView from "@/components/common/pdf-view.vue";
import Pagination from "@/components/pagination.vue";
import tabs from "@/components/tabs.vue";
import { getHoldingCertificateList } from "@/services";
import { generateHoldingCertPdf } from "@/services/form";
import { mapState } from "vuex";

export default {
    name: "requests",
    components: { tabs, PdfView, Pagination },

    data() {
        return {
            listData: [],
            dateRange: [],
            searchValue: "",
            status: [
                { label: "All", value: "" },
                { label: "Draft", value: "0" },
                { label: "Signed", value: "1" },
                { label: "Invalidated", value: "2" },
                { label: "Approved", value: "3" },
            ],
            selectStatus: "",
            selectDate: "",
            startDate: "",
            endDate: "",
            pageParams: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            operationData: {
                src: "",
                show: false,
            },
            holdingCertUrl: "",
            pdfDialogVisible: false,
            showPdfView: false,
        };
    },
    mounted() {
        this.getList();
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    methods: {
        createCert() {
            this.$router.push({
                path: "/holdingCertificate/index",
                query: {
                    pageStatus: 2,
                },
            });
            this.$emit("upindex", this.upIndex);
            sessionStorage.setItem("pageStatus", 2);
            sessionStorage.setItem("editData", JSON.stringify({}));
        },
        getCellStyle({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return {
                    backgroundColor: "rgba(255,255,255,0.2)",
                };
            } else {
                return {
                    backgroundColor: "rgba(228,228,228,0.2)",
                };
            }
        },
        handleSelectChange() {
            this.getList();
        },
        getList() {
            let data = {
                ...this.pageParams,
            };
            if (this.selectStatus) {
                data["status"] = this.selectStatus;
            }
            if (this.searchValue) {
                data["searchValue"] = this.searchValue;
            }
            if (this.dateRange && this.dateRange.length === 2) {
                data["startDate"] = this.dateRange[0];
                data["endDate"] = this.dateRange[1];
            }

            getHoldingCertificateList(data).then((res) => {
                this.listData = res.data.rows.map((item) => (
                    {
                        ...item,
                        tanks: item.tanks.map((tank) => tank.tankNumber),
                        products: item.tanks.map((tank) => tank.product)
                    }));
                this.total = res.data.total;
            });
        },
        getCellStyle({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return {
                    backgroundColor: "rgba(255,255,255,0.2)",
                };
            } else {
                return {
                    backgroundColor: "rgba(228,228,228,0.2)",
                };
            }
        },
        getStatusLabel(value) {
            const found = this.status.find(s => s.value === String(value));
            return found ? found.label : value;
        },
        getStatusColor(value) {
            switch (value) {
                case 1:
                    case 3:
                    return { color: "#4CAF50" }; // Signed - Green
                case 2:
                    return { color: "#F44336" }; // Invalidated - Red
                default:
                    return { color: "#000000" }; // Default - Black
            }
        },
        handleTableRowClick(row) {
            this.$router.push({
                path: "/holdingCertificate/index",
                query: {
                    id: row.id,
                    pageStatus: 1,
                },
            });
            sessionStorage.setItem("pageStatus", 1);
            return;
        },
        async handleViewPdf(id) {
            const response = await generateHoldingCertPdf(id);
            const blob = new Blob([response], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(blob);
            this.holdingCertUrl = fileURL;
            this.pdfDialogVisible = true;
            this.showPdfView = true;
        },
    },
};
</script>

<style scoped lang="scss">
.Topinp {
    position: relative;
}

.Topinput {
    display: flex;
    position: absolute;
    top: -65px;
    right: -40px;

    .Comipt {
        width: 275px;
        height: 46px;
    }

    .Pendingselect {
        width: 221px;
        height: 46px;
        margin-left: 16px;
    }
}

.Reqcol {
    display: flex;
    justify-content: center;
    height: calc(90vh - 80px - 32 * 2px - 56px);
    overflow-y: scroll;

    .ReqTable {
        width: 1000px;
    }

    .el-button--default {
        color: #fff;
        background-color: #008CDB;
    }

    .el-button--default.is-plain:hover {
        color: #fff;
        background: #008CDB;
        border-color: #008CDB;
    }

    .el-button--default:focus {
        color: #fff !important;
        background: #008CDB !important;
        border-color: #008CDB;
    }
}

::v-deep {
    .el-input__icon.el-icon-search {
        height: 32px !important;
    }
}

::v-deep .pagination-container {
    background: #f2f7fa;
}

::v-deep .el-input__suffix-inner {
    padding-right: 5px;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;

    svg {
        width: 13px;
        height: 13px;
        cursor: pointer;
    }
}

::v-deep .pagination-container {
    padding: 5px 0 5px 0;
}

::v-deep .Comtable .el-table div {
    word-break: break-word !important;
}

@media (max-width: 1023px) {
    .Comtable {
        height: calc(100vh - 175px);
    }

    .mobile-view {
        .Comtable {
            height: calc(100vh - 115px);
        }
    }
}

@media (min-width: 1024px) {
    .Comtable {
        height: calc(100vh - 180px);
    }
}

.el-button--default {
    color: #fff;
    background-color: #008CDB;
}

.el-button--default.is-plain:hover {
    color: #fff;
    background: #008CDB;
    border-color: #008CDB;
}

.el-button--default:focus {
    color: #fff !important;
    background: #008CDB !important;
    border-color: #008CDB;
}

.Cbnbtn {
    text-align: right;
    /* margin-top: 38px; */
    /* padding-right: 36px; */
    /* padding-right: 2rem; */
}
</style>